import React from 'react';

// Hujjat tili - erkin matnli maydonlar (bajarish muddati, vakil lavozimi,
// "boshqa" ish turi, qo'shimcha tekshiruv bandlari, izohlar) tarjima
// qilinmaydi, PDF'ga aynan yozilgandek chiqadi. Shuning uchun forma shu
// matnlarni hujjat tilida yozishni eslatadi; PDF yuklashda ham shu til tanlanadi.
export type DocLang = 'uz' | 'ru' | 'en';

export const DOC_LANG_LABELS: Record<DocLang, string> = { uz: "O'zbekcha (UZ)", ru: 'Ruscha (RU)', en: 'Inglizcha (EN)' };

export const DocLangSelect: React.FC<{ value: string; onChange: (v: DocLang) => void; className?: string }> = ({ value, onChange, className }) => (
  <div className={className}>
    <label className="block text-xs font-medium text-gray-700 mb-1">Hujjat tili</label>
    <select value={value || 'uz'} onChange={e => onChange(e.target.value as DocLang)}
      className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
      {(Object.keys(DOC_LANG_LABELS) as DocLang[]).map(l => <option key={l} value={l}>{DOC_LANG_LABELS[l]}</option>)}
    </select>
  </div>
);

export const DocLangHint: React.FC<{ lang?: string | null }> = ({ lang }) => (
  <p className="text-[11px] text-amber-700 mt-0.5">
    ✍ Matnni hujjat tilida ({(lang || 'uz').toUpperCase()}) yozing - erkin matn tarjima qilinmaydi.
  </p>
);
